import { useEffect } from 'react';

const VersionChecker = () => {
  useEffect(() => {
    const checkVersion = () => {
      const currentVersionMeta = document.querySelector('meta[name="app-version"]');
      const currentVersion = currentVersionMeta?.getAttribute('content');

      const lastKnownVersion = localStorage.getItem('app-version');

      if (currentVersion && lastKnownVersion && currentVersion !== lastKnownVersion) {
        const cacheKeysToRemove = ['react-query-cache', 'query-cache', 'app-cache', 'version-cache'];

        cacheKeysToRemove.forEach(key => {
          if (localStorage.getItem(key)) {
            localStorage.removeItem(key);
          }
        });

        if (window.queryClient) {
          window.queryClient.clear();
        }

        window.location.reload(true);
      }

      if (currentVersion) {
        localStorage.setItem('app-version', currentVersion);
      }
    };

    checkVersion();

    const interval = setInterval(checkVersion, 3600000);

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default VersionChecker;
